var map = {
	"./avatar_frames": 246,
	"./avatar_frames.ts": 246,
	"./avatars": 5434,
	"./avatars.ts": 5434,
	"./boosters": 65191,
	"./boosters.ts": 65191,
	"./cash_packs": 30690,
	"./cash_packs.ts": 30690,
	"./elixir_packs": 32204,
	"./elixir_packs.ts": 32204,
	"./flags": 62649,
	"./flags.ts": 62649,
	"./gear_packs": 79697,
	"./gear_packs.ts": 79697,
	"./gold_coin_packs": 13300,
	"./gold_coin_packs.ts": 13300,
	"./gold_packs": 3678,
	"./gold_packs.ts": 3678,
	"./keys": 96711,
	"./keys.ts": 96711,
	"./power_packs": 21955,
	"./power_packs.ts": 21955,
	"./shields": 77615,
	"./shields.ts": 77615,
	"./time_boosters": 31454,
	"./time_boosters.ts": 31454,
	"./vip_items": 98471,
	"./vip_items.ts": 98471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48061;